module.exports = __webpack_public_path__ + "img/zhimei-case04.7689f561.jpeg";